export default __webpack_public_path__ + "b3e9d3022664e234392eac6a8292a965.png";